































import { Component, Prop, Vue } from 'vue-property-decorator';
import { eventBus } from '@/constants/bus';

@Component
export default class Ligne extends Vue {
	private dotHoverIndex: boolean | null = null;

	get ActiveGrandePeriode(): any {
		return this.$store.getters['getActiveGrandePeriode'];
	}

	get ActivePeriodeIndex(): any {
		return this.$store.getters['getActivePeriodeIndex'];
	}

	get ActiveGrandePeriodeIndex(): any {
		return this.$store.getters['getActiveGrandePeriodeIndex'];
	}

	private onDotClick(index: number) {
		eventBus.$emit(this.ActiveGrandePeriodeIndex + 'periodeChange', index);
		this.$store.commit('setActivePeriodeIndex', index);
	}
}
